export default __webpack_public_path__ + "ab92ad6d992f203adfc29fddf0efd3e6.svg";